function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { convertFormDataToDigitalEditUpdateRequest } from 'shared/view/digital-edit-conversion-service';
import { Controls, validators, useFormHelpers } from 'shared/helper/form';
import Files, { endpoints, Components } from 'shared/helper/file';
import { T } from 'shared/helper/translate';
import DigitalEditUploadButton from './DigitalEditUploadButton';
var fileType = 'digitalEdit';
var Errors = Controls.Errors,
  Form = Controls.Form,
  Radio = Controls.Radio;
var notEmpty = validators.notEmpty;
var FileWithPopoverErrorStatus = Components.FileWithPopoverErrorStatus;
var defaultValues = {
  digitalEditFiles: [],
  styleOfEnglish: ''
};
var SubmitDigitalEditForm = function SubmitDigitalEditForm(_ref) {
  var createDigitalEdit = _ref.createDigitalEdit;
  var methods = useForm({
    defaultValues: defaultValues,
    shouldFocusError: false
  });
  var _useFormHelpers = useFormHelpers(),
    preprocessData = _useFormHelpers.preprocessData;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    submitting = _useState2[0],
    setSubmitting = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    dragActive = _useState4[0],
    setDragActive = _useState4[1];
  var _methods$watch = methods.watch(['digitalEditFiles']),
    _methods$watch2 = _slicedToArray(_methods$watch, 1),
    digitalEditFiles = _methods$watch2[0];
  var hasFile = digitalEditFiles && digitalEditFiles.length > 0;
  var submitDigitalEdit = function submitDigitalEdit(data) {
    setSubmitting(true);
    createDigitalEdit(data).then(function () {
      window.scrollTo(0, 0);
      setSubmitting(false);
      methods.reset(defaultValues);
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "p-3 submit-digital-edit-form mt-2 ".concat(dragActive ? 'hovered' : '')
  }, /*#__PURE__*/React.createElement(Form, {
    methods: methods,
    onSubmit: preprocessData(convertFormDataToDigitalEditUpdateRequest, submitDigitalEdit)
  }, /*#__PURE__*/React.createElement("div", {
    className: "row text-small"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6"
  }, /*#__PURE__*/React.createElement("label", {
    className: "control-label text-secondary text-transform-none"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Manuscript File (.doc or .docx)"
  })), /*#__PURE__*/React.createElement(Files, {
    apiRoot: endpoints.researcher,
    maxUploads: 1,
    methods: methods,
    name: "digitalEditFiles",
    type: fileType,
    disabled: submitting,
    fileRenderer: FileWithPopoverErrorStatus,
    required: true,
    fileUploadButton: function fileUploadButton(_ref2) {
      var onClick = _ref2.onClick,
        isDragActive = _ref2.isDragActive,
        disabled = _ref2.disabled;
      return /*#__PURE__*/React.createElement(DigitalEditUploadButton, {
        onClick: onClick,
        isDragActive: isDragActive,
        disabled: disabled,
        onDragStatusChanged: function onDragStatusChanged(active) {
          return setDragActive(active);
        },
        hasFile: hasFile
      });
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-3"
  }, /*#__PURE__*/React.createElement(Radio, {
    label: "Style of English",
    name: "styleOfEnglish",
    validators: {
      notEmpty: notEmpty
    },
    styles: {
      label: 'text-secondary text-transform-none',
      wrapper: 'mb-3 control-group pb-0'
    },
    options: [{
      value: 'British English',
      label: /*#__PURE__*/React.createElement(T, {
        source: "British English"
      })
    }, {
      value: 'American English',
      label: /*#__PURE__*/React.createElement(T, {
        source: "American English"
      })
    }]
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-3"
  }, /*#__PURE__*/React.createElement("button", {
    disabled: submitting,
    type: "submit",
    className: "btn btn-primary mt-3 position-relative rounded text-transform-none"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Begin Editing"
  }), submitting ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-1",
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }) : null))), /*#__PURE__*/React.createElement(Errors, {
    name: "styleOfEnglish",
    messages: {
      notEmpty: 'Please select your preferred type of English.'
    }
  })));
};
export default SubmitDigitalEditForm;